import React, { useState, useEffect, useRef } from "react";
import { DateRangePicker } from "react-date-range";
import { format } from "date-fns";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  TextField,
} from "@mui/material";
import TodayIcon from "@mui/icons-material/Today";
import dayjs from "dayjs";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css"; // theme css file

interface Props {
  startDate: Date;
  endDate: Date;
  setStartDate: (date: Date) => void;
  setEndDate: (date: Date) => void;
}

const DateRangeComponent = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}: Props) => {
  const calendarRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [state, setState] = useState([
    {
      startDate: new Date(startDate),
      endDate,
      key: "selection",
    },
  ]);
  const [rangeDate, setRangeDate] = useState("");
  const nowDate = dayjs().toDate();

  const closeCal = (event: any) => {
    if (
      calendarRef.current &&
      !calendarRef.current?.contains(event.target) &&
      inputRef.current &&
      !inputRef.current?.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };
  const handleTextFieldClick = () => {
    setIsOpen(true);
  };
  const onSetRangeValue = () => {
    const start = format(state[0].startDate, "yyyy/MM/dd");
    const end = format(state[0].endDate, "yyyy/MM/dd");
    setRangeDate(`${start} ~ ${end}`);
  };

  useEffect(() => {
    onSetRangeValue();
    setStartDate(state[0].startDate);
    setEndDate(state[0].endDate);
  }, [state]);

  useEffect(() => {
    document.addEventListener("click", closeCal);
    return () => {
      document.removeEventListener("click", closeCal);
    };
  }, []);

  return (
    <div style={{ position: "relative", zIndex: 2 }}>
      <TextField
        style={{ position: "relative", zIndex: 2, width: 260 }}
        onClick={handleTextFieldClick}
        ref={inputRef}
        size="small"
        label="Date"
        value={rangeDate}
        InputProps={{
          endAdornment: <TodayIcon />,
        }}
      />

      <div
        ref={calendarRef}
        className={isOpen ? "open-cal" : ""}
        style={{
          display: "block",
          marginTop: "15px",
          width: "450px",
        }}
      >
        <DateRangePicker
          maxDate={nowDate}
          editableDateInputs={true}
          onChange={(item: any) => {
            setState([item.selection]);
          }}
          moveRangeOnFirstSelection={false}
          ranges={state}
          months={2}
          direction="horizontal"
        />
      </div>
    </div>
  );
};

export default DateRangeComponent;
